import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_284_1049)">
      <path
        d="M12.4176 11.6086C12.245 12.4198 11.5286 12.9998 10.6993 12.9998L3.17904 12.9998C2.3497 12.9998 1.63334 12.4198 1.46074 11.6086L0.244989 5.89454C0.0967548 5.19784 0.383883 4.48058 0.971929 4.07863L5.94782 0.677391C6.54557 0.268802 7.33277 0.268802 7.93052 0.677391L12.9064 4.07863C13.4945 4.48059 13.7816 5.19784 13.6333 5.89454L12.4176 11.6086Z"
        fill="url(#paint0_linear_284_1049)"
      />
      <g clipPath="url(#clip1_284_1049)">
        <path
          d="M8.37258 10.362L10.7418 4.45459H9.19153C9.02162 4.45459 8.85561 4.50547 8.71487 4.60066C8.57413 4.69585 8.46512 4.83101 8.40188 4.98871L7.36071 7.58628L8.37258 10.362Z"
          fill="white"
          style={{ fill: "white", fillOpacity: 1 }}
        />
        <path
          d="M8.06449 11.006H6.51493C6.34488 11.006 6.17874 10.9551 6.03789 10.8598C5.89704 10.7645 5.78796 10.6292 5.72468 10.4714L3.3117 4.45508H4.86081C5.03106 4.4551 5.1974 4.50612 5.33838 4.60156C5.47937 4.697 5.58853 4.83248 5.6518 4.99054L8.06449 11.006Z"
          fill="white"
          style={{ fill: "white", fillOpacity: 1 }}
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_284_1049"
        x1="11.4708"
        y1="14.3398"
        x2="3.21183"
        y2="-0.801642"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#8898A7"
          style={{ stopColor: "#8898A7", stopOpacity: 1 }}
        />
        <stop
          offset="0.42008"
          stopColor="#A7B1BA"
          style={{ stopColor: "#A7B1BA", stopOpacity: 1 }}
        />
        <stop
          offset="1"
          stopColor="#DEDFE0"
          style={{ stopColor: "#DEDFE0", stopOpacity: 1 }}
        />
      </linearGradient>
      <clipPath id="clip0_284_1049">
        <rect
          width="13.8784"
          height="13"
          fill="white"
          style={{ fill: "white", fillOpacity: 1 }}
        />
      </clipPath>
      <clipPath id="clip1_284_1049">
        <rect
          width="8.43243"
          height="8.43243"
          fill="white"
          style={{ fill: "white", fillOpacity: 1 }}
          transform="translate(2.81076 3.51331)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
